<template>
	<Autocomplete
		:display-name="label"
		:icon="icon"
		:label="label"
		:name="name"
		endpoint="craftsman_task_types"
		item-title="name"
		v-bind="$attrs"
		data-test="craftsman_task_types-autocomplete"
		:params="{ of: 'name', od: 'ASC' }"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: 'fa-regular fa-tags',
		type: String,
	},
	label: {
		default: 'component.craftsmanTasks.craftsmanTaskType',
		type: String,
	},
	name: {
		default: 'craftsmanTaskTypes',
		type: String,
	},
})
</script>

<style scoped></style>
